module.exports = __webpack_public_path__ + "static/media/IconTemplates_-100.7afc1d3b.svg";